import React from 'react';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import styles from './VideoMeetingsScreen.module.css';

const DirectCall = ({ setMode, availableUsers, loading, selectedUser, setSelectedUser, handleDirectCall }) => {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <div className={styles.container}>
        <div className={styles.card}>
          <button className={styles.backButton} onClick={() => setMode(null)}>
            {t('screens.video.meetings.back')}
          </button>

          <div className={styles.header}>
            <h1 className={styles.title}>{t('screens.video.meetings.directCallTitle')}</h1>
            <p className={styles.subtitle}>{t('screens.video.meetings.selectPersonToCall')}</p>
          </div>

          {loading ? (
            <div className={styles.loading}>{t('screens.video.meetings.loadingUsers')}</div>
          ) : (
            <>
              <div className={styles.userList}>
                {availableUsers.length === 0 ? (
                  <p className={styles.noUsers}>{t('screens.video.meetings.noUsersAvailable')}</p>
                ) : (
                  availableUsers
                    .sort((a, b) => {
                      const nameA = a.name.toLowerCase();
                      const nameB = b.name.toLowerCase();
                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;
                      return 0;
                    })
                    .map(user => (
                      <div key={user._id} className={`${styles.userCard} ${selectedUser?._id === user._id ? styles.selected : ''}`} onClick={() => setSelectedUser(user)}>
                        <div className={styles.userAvatar}>{user.name?.charAt(0) || '?'}</div>
                        <div className={styles.userInfo}>
                          <div className={styles.userName}>{user.name}</div>
                          <div className={styles.userRole}>{user.role || t('screens.video.meetings.roleFallback')}</div>
                        </div>
                        {selectedUser?._id === user._id && <div className={styles.checkmark}>✓</div>}
                      </div>
                    ))
                )}
              </div>

              <div className={styles.actions}>
                <button className={styles.cancelButton} onClick={() => setMode(null)}>
                  {t('screens.video.meetings.cancel')}
                </button>
                <button className={`${styles.callButton} ${!selectedUser ? styles.disabled : ''}`} onClick={handleDirectCall} disabled={!selectedUser}>
                  {t('screens.video.meetings.call')}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </AppLayout>
  );
};

export default DirectCall;
